import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá, gostaria de receber atendimento.');
    window.open(`https://wa.me/5511933728770?text=${message}`, '_blank');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Convertrex</h3>
            <p>{t('footer.description')}</p>
          </div>

          <div className="footer-section">
            <h4>{t('footer.quickLinks.title')}</h4>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><a href="/#about">{t('nav.about')}</a></li>
              <li><a href="/#solutions">{t('nav.services')}</a></li>
              <li><Link to="/planos">{t('nav.plans')}</Link></li>
              <li><a href="/#contact">{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.services.title')}</h4>
            <ul>
              <li><a href="/#solutions">{t('services.items.web.title')}</a></li>
              <li><a href="/#converlead">{t('footer.services.converlead')}</a></li>
              <li><a href="/#axys">{t('footer.services.axys')}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.contact.title')}</h4>
            <ul className="contact-info">
              <li>{t('contact.info.email.content')}</li>
              <li>{t('contact.info.phone.content')}</li>
            </ul>
            <div className="social-links">
              <a href="https://facebook.com/convertrex" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://instagram.com/convertrex_tech" target="_blank" rel="noopener noreferrer" aria-label="Instagram @convertrex_tech">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com/company/convertrexbr" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <button onClick={handleWhatsAppClick} className="whatsapp-link">
                <FaWhatsapp />
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-rights">
            <p>© 2026 Convertrex. {t('footer.rights')}</p>
            <p className="footer-legal">
              <a href="/privacidade/">Privacidade</a>
              {' · '}
              <a href="/termos/">Termos</a>
              {' · '}
              <a href="/exclusao-de-dados/">Exclusão de dados</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
